<template>
  <div class="bs-list">
    <form v-on:submit.prevent>
      <label for="stationSearch">
        Søk etter sykkelstativ
      </label>
      <input
        type="search"
        id="stationSearch"
        v-model="search"
        placeholder="Sted"
      />
    </form>
    <ul>
      <li v-for="(station, i) in filteredList" :key="`station-${i}`">
        <BSStation :station="station" />
      </li>
    </ul>
  </div>
</template>

<script>
import BSStation from './BSStation.vue'
export default {
  name: 'BSList',
  components: {
    BSStation,
  },
  data() {
    return {
      search: '',
    }
  },
  props: {
    stations: Array,
  },
  computed: {
    filteredList() {
      return this.stations.filter(station => {
        return station.name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
}
</script>

<style lang="scss">
.bs-list {
  padding-top: 4rem;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
  }
  li {
    padding: 1rem;
    margin: 1rem;
    flex: 1 1 20rem;
    border: 1px solid black;
    border-radius: 1rem;
  }
  h2 {
    margin-top: 0;
  }
  p {
    margin-bottom: 0;
  }
  form {
    padding: 1rem;
    margin: 1rem;
    border: 0;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: baseline;
    @media screen and (max-width: 700px) {
      flex-direction: column;
    }
  }
  label {
    flex: 0 0 auto;
    padding-right: 1rem;
    @media screen and (max-width: 700px) {
      width: 100%;
      flex: 1 1 100%;
      padding-right: 0;
    }
  }
  input {
    appearance: none;
    -webkit-appearance: none;
    flex: 1 1 auto;
    font-size: inherit;
    font-family: inherit;
    padding: 1rem;
    border: 0;
    border-bottom: 1px solid black;
    border-radius: 0;
    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px black;
    }
    @media screen and (max-width: 700px) {
      flex: 1 1 100%;
      width: 100%;
      padding: 1rem 0;
    }
  }
}
</style>
